import { Icon } from '@components/common/generic-icon';
import { Badge } from '@components/common/badge';
import React from 'react';
import { Theme, ThemeProps } from '@theme/base';
import styled from '@emotion/styled';
import { ImageDestination } from '@model/iceberg';
import { withTheme } from '@emotion/react';
import { TripTypes } from '@model/common';

export interface BottomProps {
  destination: ImageDestination;
  theme?: Theme;
  tripType?: TripTypes;
}
const DestinationBadgeContainer: any = styled.div<any>({
  position: 'absolute',
  bottom: 0,
  right: 0,
  textAlign: 'center'
});

const LocationIcon = styled(Icon)(({ theme }: ThemeProps) => ({
  fontSize: '2rem',
  color: theme.custom.states.link.default
}));

export const BottomComponent = ({ theme, destination }: BottomProps) => {
  if (!destination || !destination.name) return null;
  return (
    <>
      {destination.name && (
        <DestinationBadgeContainer className={'badgeContainer'}>
          <Badge
            label={`${destination.name}, ${destination.parent}`}
            containerStyle={{ backgroundColor: theme!.custom.colors.white, margin: 20 }}
            tooltip={'hero__button--tooltip'}
            renderIcon={<LocationIcon name={'mhi-map-pin'} />}
          />
        </DestinationBadgeContainer>
      )}
    </>
  );
};

export const Bottom = withTheme(BottomComponent);
